import { createSelector } from 'reselect';

const selectBankConfigurations = (state: any) => state.bankConfigurations;

export const selectBankConfigurationsCurrentItem = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.current);

export const selectBankConfigurationsListItems = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.list);

export const selectBankConfigurationsItemById = (itemId: any) =>
    createSelector(selectBankConfigurationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBankConfigurationsQueryItems = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.query);

export const selectBankConfigurationsCreatedItem = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.create);

export const selectBankConfigurationsUpdatedItem = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.update);

export const selectBankConfigurationsReadItem = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.read);

export const selectBankConfigurationsDeletedItem = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.delete);

export const selectBankConfigurationsSearchedItems = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.search);

export const selectBankConfigurationsItemsCount = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.count);

export const selectBankConfigurationsItemsFilter = createSelector([selectBankConfigurations], (bankConfigurations) => bankConfigurations.filter);